import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import {Auth2Service} from "../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(public auth2Service: Auth2Service, public router: Router) {}
  async canActivate(): Promise<any> {
    let idToken = this.auth2Service.getIdToken();
    let expTime: number = parseInt(this.auth2Service.getExp());
    let now: number = Date.now() / 1000;
    let diff = expTime - now;
    if (idToken) {
      if (diff <= 3000) {
        this.auth2Service.isUserAuthenticated().subscribe((result: any) => {
          if (result && result.body) {
            if (result.body.loggedInStatus) {
              if (result.body.refreshFlag) {
                this.auth2Service.cacheSessionFull(result.body)
              }
              return true
            } else {
              localStorage.removeItem('lastSearchGrant');
              localStorage.removeItem('lastSearchGrantExpTime');
              localStorage.removeItem('lastSearchDonor');
              localStorage.removeItem('lastSearchDonorExpTime');
              localStorage.removeItem('lastSearchNonprofit');
              localStorage.removeItem('lastSearchNonprofitExpTime');
              this.router.navigateByUrl('app/login');
              return false;
            }
          }
          return false;
        }, (error: HttpErrorResponse) => {
          return false;
        })
      } else {
        return true;
      }
    } else {
      this.router.navigateByUrl('app/login');
    }
  }
}
/*
@Injectable()
export class BasicAuthGuard implements CanActivate {
  constructor(public auth: AuthService, public router: Router) {}
  async canActivate() {
    const authenticated = this.auth.isAuthenticated();
    if (!authenticated) {
      await this.auth.login();
    }
    const hasRole = this.auth.hasRole(['USER', 'HELPDESK'])
    if (!hasRole) {
      this.router.navigate(['unauthorized']);
    }
    return hasRole;
  }
}
*/

/*
import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../services/auth.service';
import {async} from "rxjs";

@Injectable()
export class BasicAuthGuard implements CanActivate {
  constructor(public auth: AuthService, public router: Router) {}
    async canActivate() {
      const authenticated = this.auth.isAuthenticated();
      if (!authenticated) {
        await this.auth.login();
      }
      const hasRole = this.auth.hasRole(['HR_EMPLOYEE', 'HR_SUPERVISOR'])
      if (!hasRole) {
        this.router.navigate(['unauthorized']);
      }
      return hasRole;
    }
  }
}

 */
